import { ToastMessage } from "../ToastMessage.js";
import { TAsyncResult } from "../useAsyncValue.js";

type SuccessErrorToastProps = {
  result: TAsyncResult<unknown>;
  message: string;
};

export const SuccessErrorToast = ({
  result,
  message,
}: SuccessErrorToastProps) => {
  if (result.type === "REJECTED") {
    return (
      <ToastMessage
        message={result.error.message ?? "Error"}
        severity="error"
      />
    );
  }

  if (result.type === "RESOLVED") {
    return <ToastMessage message={message} severity="success" />;
  }

  return null;
};
